import { useState } from 'react';
import { images } from '../../assets/images';

const Enquiry = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    interest: '',
    message: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      // Using the same endpoint as Contact.tsx
      const res = await fetch('/api/public/enquiries', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      
      if (res.ok) {
        alert('Enquiry sent successfully! We will contact you soon.');
        setFormData({ name: '', phone: '', email: '', interest: '', message: '' });
      } else {
        // Fallback for demo/preview if backend isn't ready
        console.log('Form submitted:', formData);
        alert('Thank you for your enquiry! We will get back to you shortly.');
        setFormData({ name: '', phone: '', email: '', interest: '', message: '' });
      }
    } catch (err) {
      console.error(err);
      // Fallback for demo/preview
      alert('Thank you for your enquiry! We will get back to you shortly.');
      setFormData({ name: '', phone: '', email: '', interest: '', message: '' });
    }
  };

  return (
    <section className="py-24 relative bg-slate-900">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{ backgroundImage: `url(${images.enquiry})` }}
      ></div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-2xl overflow-hidden flex flex-col md:flex-row">
          {/* Left Side - Info */}
          <div className="bg-orange-600 p-10 md:w-2/5 text-white flex flex-col justify-center">
            <h3 className="text-3xl font-bold mb-6">Request a Quote</h3>
            <p className="mb-8 text-orange-100">
              Ready to upgrade your infrastructure? Get in touch with our sales team for a custom quote tailored to your needs.
            </p>
            <div className="space-y-4">
              <p className="font-bold">Call Us:</p>
              <p className="text-2xl">+91 797 330 9949</p>
              <p className="font-bold mt-6">Email Us:</p>
              <p className="text-lg">support@carlosonestop.com</p>
            </div>
          </div>

          {/* Right Side - Form */}
          <div className="p-10 md:w-3/5 bg-white">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Name</label>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-2 rounded border border-slate-300 focus:border-orange-500 outline-none" 
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Phone</label>
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-2 rounded border border-slate-300 focus:border-orange-500 outline-none" 
                    required
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Email</label>
                <input 
                  type="email" 
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded border border-slate-300 focus:border-orange-500 outline-none" 
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Product Interest</label>
                <select 
                  name="interest"
                  value={formData.interest}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded border border-slate-300 focus:border-orange-500 outline-none"
                >
                  <option value="">Select Product</option>
                  <option value="Capacitors">Capacitors</option>
                  <option value="Regulators">Regulators</option>
                  <option value="Motors">Motors</option>
                  <option value="Lighting">Lighting</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Message</label>
                <textarea 
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={3} 
                  className="w-full px-4 py-2 rounded border border-slate-300 focus:border-orange-500 outline-none"
                ></textarea>
              </div>
              <button type="submit" className="w-full bg-slate-900 text-white py-3 rounded font-bold hover:bg-slate-800 transition-colors">
                Submit Enquiry
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Enquiry;
